import { useState } from "react";
import { faqs } from "@/mocks/comics";

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[880px] px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-primary-600">
            <i className="ri-questionnaire-line"></i> 帮你解答
          </span>
          <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-4xl">
            常见问题
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-sm text-foreground-600 md:text-base">
            关于收藏、连载进度与更新提醒，常见疑问都帮你整理好了。
          </p>
        </div>

        <div className="mt-8 divide-y divide-background-200 rounded-lg border border-background-200 bg-background-50 px-5 md:px-8">
          {faqs.map((f, i) => {
            const open = openIndex === i;
            return (
              <div key={f.q}>
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? -1 : i)}
                  aria-expanded={open}
                  className="flex w-full items-center justify-between gap-4 py-5 text-left"
                >
                  <h3 className="text-sm font-semibold text-foreground-950 md:text-base">{f.q}</h3>
                  <i
                    className={`shrink-0 text-xl text-primary-600 transition-transform duration-300 ${
                      open ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </button>
                {open && (
                  <p className="pb-5 text-sm leading-relaxed text-foreground-600">{f.a}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}